import { BottomNavigationStateType } from '../types';

export const bottomNavigationInitialState: BottomNavigationStateType = {
  isBottomNavigationVisible: true,
};
